'use client';

import React, { createContext, useContext, useMemo } from 'react';
import { useSPARouter } from './SPARouterContext';

const LangPrefixContext = createContext({ lang: 'zh-tw', prefix: '/zh-tw' });

export const LangPrefixProvider = ({ lang, children }) => {
  const value = useMemo(() => ({
    lang,
    prefix: `/${lang}`,
    p: (path) => `/${lang}${path.startsWith('/') ? path : `/${path}`}`,
  }), [lang]);

  return (
    <LangPrefixContext.Provider value={value}>
      {children}
    </LangPrefixContext.Provider>
  );
};

export const useLangPrefix = () => useContext(LangPrefixContext);

export const useLangNavigate = () => {
  const { push, replace, back } = useSPARouter();
  const { p } = useLangPrefix();
  return (to, options) => {
    if (typeof to === 'string' && to.startsWith('/')) {
      const url = p(to);
      if (options?.replace) {
        replace(url);
      } else {
        push(url);
      }
    } else if (typeof to === 'number' && to === -1) {
      back();
    } else {
      push(to);
    }
  };
};
